import { jsxs as B, jsx as w } from "react/jsx-runtime";
import { forwardRef as G, useState as $, useRef as J, useEffect as O } from "react";
import Q from "@mui/material/Slider";
import D from "styled-components";
import X from "../FormLabel/FormLabel.js";
import Y from "../TextField/TextField.js";
const Z = {
  root: "sliderRoot",
  active: "sliderActive",
  disabled: "sliderDisabled",
  mark: "sliderMark",
  markActive: "sliderMarkActive",
  rail: "sliderRail",
  track: "sliderTrack",
  trackFalse: "sliderTrackFalse",
  trackInverted: "sliderTrackInverted",
  thumb: "sliderThumb",
  valueLabel: "sliderValueLabel",
  vertical: "sliderVertical"
}, i = {
  before: "before",
  after: "after"
}, _ = (r, o) => {
  let s;
  return r === "horizontal" ? o === "before" ? s = "0px 24px 0px 0px" : s = "0px 0px 0px 24px" : o === "before" ? s = "0px 0px 24px 0px" : s = "24px 0px 0px 0px", s;
}, q = D.div.withConfig({
  displayName: "Root"
})([
  "height:",
  ";width:",
  ";"
], ({ $orientation: r }) => r === "horizontal" ? "auto" : "100%", ({ $orientation: r }) => r === "horizontal" ? "100%" : "auto"), rr = D.div.withConfig({
  displayName: "Wrapper"
})([
  "height:100%;display:flex;flex-direction:",
  ";"
], ({ $orientation: r }) => r === "horizontal" ? "row" : "column"), E = D(Y).withConfig({
  displayName: "StyledTextField"
})([
  "&&{min-width:70px;margin:",
  ";flex:",
  ";align-items:center;& .outlinedInput{text-align:center;}}"
], ({ $orientation: r, $editorPosition: o }) => _(r, o), ({ $orientation: r }) => r === "horizontal" ? "1 0 70px" : "0"), er = D(Q).withConfig({
  displayName: "StyledMuiSlider"
})([
  "&.sliderRoot{height:8px;margin:auto;}&.sliderRoot.sliderVertical{height:100%;}&& .sliderRail{border-radius:2px;opacity:1;color:",
  ";}&&.sliderTrackInverted .sliderRail{color:",
  ";}&& .sliderTrack{border-radius:2px;color:",
  ";}&&.sliderTrackFalse .sliderTrack{color:",
  ";}&&.sliderTrackInverted .sliderTrack{color:",
  ";background-color:currentColor;border-color:currentColor;}&& .sliderThumb{width:24px;height:24px;box-shadow:0 4px 20px 0 ",
  ";background-color:",
  ";overflow:",
  ";}&& .sliderThumb:hover{overflow:visible;}&&:not(.sliderDisabled) .sliderThumb:hover,&&:not(.sliderDisabled) .sliderThumb.Mui-focusVisible{background-color:",
  ";overflow:visible;}&&:not(.sliderDisabled) .sliderThumb:hover .valueLabelContainer{background-color:",
  ";}&&:not(.sliderDisabled) .sliderThumb.sliderActive{background-color:",
  ";overflow:visible;}&&:not(.sliderDisabled) .sliderThumb.sliderActive .valueLabelContainer{background-color:",
  ";}&&.sliderDisabled .sliderThumb{width:24px;height:24px;}&&.sliderDisabled .sliderTrack,&&.sliderDisabled .sliderThumb,&&.sliderDisabled .sliderThumb.sliderActive{color:",
  ";background-color:",
  ";}&&.sliderDisabled .sliderRail{color:",
  ";}&& .sliderMark,&& .sliderMark.sliderMarkActive{opacity:1;}&& .sliderMark{height:4px;width:4px;border-radius:2px;background-color:",
  ";}&& .sliderMark.sliderMarkActive{background-color:",
  ";}&& .sliderValueLabel{height:26px;display:flex;position:absolute;top:auto;bottom:8px;align-items:center;justify-content:center;color:",
  ";background-color:",
  ";padding:3px 8px;border-radius:4px;box-sizing:border-box;transition:all 0.2s ",
  ";}&&.sliderDisabled .sliderValueLabel{color:",
  ";background-color:",
  ";}&&.sliderDisabled .sliderThumb{pointer-events:auto;}"
], ({ theme: r }) => r.isLightTheme ? r.colors.blue100 : r.colors.blue500, ({ theme: r }) => r.primaryFill, ({ theme: r }) => r.primaryFill, ({ theme: r }) => r.primaryBorder, ({ theme: r }) => r.primaryBorder, ({ theme: r }) => r.primaryShadow, ({ theme: r }) => r.primaryFill, ({ components: r, slots: o }) => (r == null ? void 0 : r.ValueLabel) === "on" || (o == null ? void 0 : o.valueLabel) === "on" ? "visible" : void 0, ({ theme: r }) => r.primaryHover, ({ theme: r }) => r.primaryHover, ({ theme: r }) => r.primaryFill, ({ theme: r }) => r.primaryFill, ({ theme: r }) => r.secondaryDisabled, ({ theme: r }) => r.secondaryDisabled, ({ theme: r }) => r.primaryDisabled, ({ theme: r }) => r.primaryFill, ({ theme: r }) => r.colors.white, ({ theme: r }) => r.colors.white, ({ theme: r }) => r.primaryFill, (r) => r.visible ? "ease-out" : "ease-in", ({ theme: r }) => r.colors.white, ({ theme: r }) => r.secondaryDisabled), M = (r, o, s, u, b = "") => {
  let l = r;
  return Array.isArray(r) ? [
    M(r[0], o, s, u, b),
    M(r[1], o, s, u, b)
  ] : (l = Math.max(o, Math.min(s, l)), l = Math.trunc(Math.round(l / u) * u * 1e6) / 1e6, Number.isNaN(l) && (l = b), l);
}, k = (r, o, s, u, b) => {
  let l = o;
  return Array.isArray(o) && (l = o[r === "before" ? 0 : 1]), l = M(l, s, u, b), l;
}, ir = /* @__PURE__ */ G(({ ariaLabelEditor: r = void 0, label: o = void 0, classes: s = void 0, className: u = void 0, defaultValue: b = void 0, disabled: l = !1, editorPosition: R = "after", error: C, min: d = 0, max: n = 100, onChange: h = void 0, onChangeCommitted: A = void 0, orientation: g = "horizontal", required: F = !1, showEditor: V = !0, step: c = 1, value: t = 0, valueLabelDisplay: j = "auto", ...K }, P) => {
  const [y, v] = $(k(i.before, b || t, d, n, c)), [m, T] = $(k(i.after, b || t, d, n, c)), p = Array.isArray(t) || Array.isArray(b), N = J(t), H = R === i.before || p, W = R === i.after || p, L = (f) => {
    const a = f.target.name, e = f.target.value;
    a === i.before && v(e), a === i.after && T(e);
    const I = parseFloat(e);
    if (!Number.isNaN(I)) {
      let x = I;
      a === i.before && p && (x = [
        x,
        m
      ]), a === i.after && p && (x = [
        y,
        x
      ]), N.current = x, h && h(void 0, x);
    }
  }, S = (f) => {
    const a = f.target.name;
    let e = parseFloat(f.target.value);
    Number.isNaN(e) ? (a === i.before && (e = p ? t == null ? void 0 : t[0] : t), a === i.after && (e = p ? t == null ? void 0 : t[1] : t)) : (e = Math.max(d, Math.min(n, e)), e = Math.round(e / c) * c), a === i.before && (v(e), p && e > m && (e = [
      Math.min(e, m),
      Math.max(e, m)
    ], h && h(void 0, e))), a === i.after && (T(e), p && y > e && (e = [
      Math.min(y, e),
      Math.max(y, e)
    ], h && h(void 0, e))), A && A(void 0, e);
  }, z = (f) => {
    f.key === "Enter" && S(f);
  }, U = (f, a) => {
    l || (v(k(i.before, a, d, n, c)), T(k(i.after, a, d, n, c)), N.current = a, h && h(f, a));
  };
  return O(() => {
    t !== N.current && (v(k(i.before, t, d, n, c)), T(k(i.after, t, d, n, c)));
  }, [
    t,
    d,
    n,
    c,
    y,
    m
  ]), /* @__PURE__ */ B(q, {
    className: u,
    $orientation: g,
    children: [
      o && /* @__PURE__ */ w(X, {
        error: C,
        required: F,
        disabled: l,
        children: o
      }),
      /* @__PURE__ */ B(rr, {
        $orientation: g,
        children: [
          V && H && /* @__PURE__ */ w(E, {
            name: i.before,
            type: "number",
            slotProps: {
              htmlInput: {
                min: d,
                max: n,
                step: c,
                "aria-label": r
              }
            },
            disableClear: !0,
            value: y,
            onChange: L,
            onBlur: S,
            onKeyDown: z,
            required: F,
            disabled: l,
            $editorPosition: i.before,
            $orientation: g
          }),
          /* @__PURE__ */ w(er, {
            ...K,
            orientation: g,
            ref: P,
            classes: {
              ...Z,
              ...s
            },
            min: d,
            max: n,
            step: c,
            onChange: U,
            onChangeCommitted: A,
            defaultValue: b,
            value: M(t, d, n, c, d),
            disabled: l,
            valueLabelDisplay: j
          }),
          V && W && /* @__PURE__ */ w(E, {
            name: i.after,
            type: "number",
            slotProps: {
              htmlInput: {
                min: d,
                max: n,
                step: c,
                "aria-label": r
              }
            },
            disableClear: !0,
            value: m,
            onChange: L,
            onBlur: S,
            onKeyDown: z,
            required: F,
            disabled: l,
            $editorPosition: i.after,
            $orientation: g
          })
        ]
      })
    ]
  });
});
ir.displayName = "Slider";
export {
  ir as default
};
